//API helper to centralize API calls and automatically attach token from sessionStorage
import axios from "axios";
import { APP_API_URL } from "../constants/appURLConstrants";

// const api = axios.create({
//   baseURL: APP_API_URL,
// });

// // ✅ Automatically attach token
// api.interceptors.request.use((config) => {
//   const token = sessionStorage.getItem("token");

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// export default api;





const api = axios.create({
  baseURL: APP_API_URL,
});

// ✅ Attach token
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ✅ HANDLE EXPIRED TOKEN
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("🔒 Token expired or invalid");

      // ❌ clear session
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");

      // 🔁 redirect to login
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default api;